import useLanguage from "@casino/legacy/client/hooks/useLanguage";
import useUserGeoLocation from "@casino/legacyUi/form/FormPhoneNumber/hooks/useUserGeoLocation";

type ConnectionType = Site | LanguageCode;

const sorting: Partial<Record<string, Connection[]>> = {
  ko: [
    "metamask",
    "google-oauth2",
    "facebook",
    "line",
    "telegram",
    "twitter",
    "apple",
  ],
  eu: [
    "metamask",
    "google-oauth2",
    "facebook",
    "twitter",
    "line",
    "telegram",
    "apple",
  ],
  pt: [
    "metamask",
    "google-oauth2",
    "facebook",
    "twitter",
    "telegram",
    "line",
    "apple",
  ],
  ja: [
    "line",
    "twitter",
    "google-oauth2",
    "metamask",
    "facebook",
    "telegram",
    "apple",
  ],
};

const connectionOrder: Partial<Record<ConnectionType, Connection[]>> = {
  pt: sorting.pt,
  ko: sorting.ko,
  en: sorting.eu,
  es: sorting.eu,
  ja: sorting.ja,
  th: sorting.ja,
};

const useConnectionOrder = () => {
  const { code } = useLanguage();
  const { userGeoCountryCode } = useUserGeoLocation();
  const isJa = userGeoCountryCode === "JP";
  const countryCodeformGeoLocation = isJa ? "ja" : code;

  const order =
    connectionOrder[countryCodeformGeoLocation] ?? connectionOrder.en ?? [];
  return order;
};

export default useConnectionOrder;
